import { isBefore, isSameDay, isValid, parseISO, startOfDay } from 'date-fns';
import { SweepstakesPrize } from 'features/incentive/content/sweepstakesContentV1';

export const getNextDrawingPrizes = (
  prizeSchedule: SweepstakesPrize[],
  today: Date,
): SweepstakesPrize[] => {
  const startOfToday = startOfDay(today);
  const upcomingPrizes = prizeSchedule
    .map((prize) => ({ prize, date: parseISO(prize.date) }))
    .filter(({ date }) => isValid(date) && !isBefore(date, startOfToday));

  if (upcomingPrizes.length === 0) {
    return [];
  }

  const nextDrawingDate = upcomingPrizes.reduce(
    (earliest, { date }) => (isBefore(date, earliest) ? date : earliest),
    upcomingPrizes[0].date,
  );

  return upcomingPrizes
    .filter(({ date }) => isSameDay(date, nextDrawingDate))
    .map(({ prize }) => prize);
};
